<template>
  <div class="changePassword">
    <!-- start change password part -->
    <div class="col-sm-6 the-form">
      <q-linear-progress indeterminate v-if="loading"></q-linear-progress>
      <div class="form-body">
        <!-- form -->
        <q-form @submit.prevent="updateYoutubeURL">
          <!-- form inputs -->
          <label>Add YouTube link of your strategy of coding:<br />Before 30th of June</label>
          <q-input type="url" reactive-rules label-color="secondary" filled v-model="formData.url"
            label="Enter Youtube URL" />
          <div v-if="!validateYoutubeURL && formData.url">Please enter valid youtube video url.</div>
          <div class="submit">
            <div class="the-button">
              <button class="wro-button secondaryButtons" :disabled="!validateYoutubeURL"><span>Save
                  Changes</span></button>
              <span class="skew-line-w"></span>
            </div>
            <!-- end send message  button -->
          </div>
        </q-form>
        <!-- end form -->
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "SubmitVideo",
  data() {
    return {
      formData: {
        url: ""
      },
      loading: false,
    };
  },
  created() {
    this.getYoutubeVideo();
  },
  computed: {
    validateYoutubeURL() {
      if (this.formData.url && this.formData.url.match(/^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/)) {
        return true
      }
      return false;
    },
  },
  methods: {
    getYoutubeVideo() {
      this.loading = true;
      this.$API.userProfile.getYoutubeVideo()
        .then(response => {
          this.loading = false;
          this.formData.url = response?.data?.url;
        })
        .catch(error => {
          this.formErrors = error.response.data.message;
          this.loading = false;
        });
    },
    updateYoutubeURL() {
      this.loading = true;
      this.$API.userProfile.updateYoutubeURL(this.formData)
        .then(response => {
          this.loading = false;
          this.formDone = response.data.message;
          this.$q.notify({
            message: 'Your YouTube video successfully posted.',
            color: 'green'
          })
        })
        .catch(error => {
          this.formErrors = error.response.data.message;
          this.loading = false;
        });
    }
  },
};
</script>


<style scoped>

</style>
